import { AfterViewInit, Directive, Input } from '@angular/core';
import { LcsMultiSelectComponent } from '@lcs/shared/multi-select';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { FormatPhoneNumbersPipe } from 'src/app/pipes/format-phone-numbers/format-phone-numbers.pipe';
import { PhoneNumberOption } from '../models/phone-number-option';
import { PhoneNumberMultiSelectDataSource } from './phone-number-multi-select-data-source';

@Directive({
    selector: 'lcs-multi-select[ndtPhoneNumberMultiSelect]',
    standalone: false
})
export class PhoneNumberMultiSelectDirective implements AfterViewInit {
   @Input() accountId: number | null;

   constructor(private multiSelect: LcsMultiSelectComponent<PhoneNumberOption>, private store: Store<AppState>) {
      this.multiSelect.data = new PhoneNumberMultiSelectDataSource(this.store, []);
      const formatPhoneNumbersPipe = new FormatPhoneNumbersPipe();
      this.multiSelect.displayWith = (item: PhoneNumberOption | null) => {
         return item ? formatPhoneNumbersPipe.transform(item.phoneNumber) : null;
      };
   }

   ngAfterViewInit(): void {
      const staticFilterOverride: string[] = [];

      if (this.accountId) {
         staticFilterOverride.push(`AccountId = ${this.accountId}`);
      }

      // This is being set twice because the lcs shared component we're using for some reason only checks the validity of the selectAll button's existence once
      this.multiSelect.data = new PhoneNumberMultiSelectDataSource(this.store, staticFilterOverride);
   }
}
